<template>
  <div>PreNatal</div>
</template>

<script>
export default {}
</script>

<style></style>
